/** @format */

import NumberInputField from '../form/number_input_field';
import React, {useContext} from 'react';
import SuperAgent from 'superagent';
import {ConditionalButton} from 'frontier-utilities';
import PushableRequestButton from 'frontier/utilities/pushable_request_button';
import {CartOverviewContext} from 'frontier/cart/components/cart_overview/cart_overview_context';

export const SingleDesignQty = ({designOrder, ...props}) => {
    const ctx = useContext(CartOverviewContext);
    const [isDeleting, setIsDeleting] = React.useState(false);
    const updateQty = ({value}) => {
        value = parseInt(value.toString().replace(/[^0-9.]/g, ''));
        value = value > 0 ? value : 1;

        let newValue = props.designs_orders.reduce((a, b) => a + b.qty, 0);
        newValue = newValue - designOrder.qty; // remove the prev design qty
        newValue = newValue + value; // replace it with the new one

        newValue = parseFloat(newValue);

        props.onChangeOrder(props.id, designOrder.id, {
            total_qty: {$set: parseFloat(newValue)},
            designs_orders: {[props.index]: {qty: {$set: value}}}
        });
    };

    const isFieldSaving = props.fieldsSaving.some(field => field.fieldName === designOrder.id);

    return isFieldSaving ? (
        <i className="fa fa-spinner fa-spin" />
    ) : (
        <div className="d-inline-block d-flex">
            <div>
                <NumberInputField
                    isEditable={!props.is_printed_proof_only && props.fieldsSaving.length === 0}
                    saving={isFieldSaving}
                    value={designOrder.qty}
                    onUpdate={value => updateQty(value)}
                    numberFormatProps={{
                        decimalScale: 0,
                        fixedDecimalScale: true,
                        thousandSeparator: true
                    }}
                />
            </div>
            {props.designs_orders.length > 1 && (
                <div className="ms-2">
                    <PushableRequestButton
                        className="btn btn-danger d-inline-block ms-2 d-flex align-items-center justify-content-center"
                        style={{height: 30}}
                        endpoint={`/account/designs/delete/${designOrder.id}`}
                        onDone={() => {
                            const orderIndex = ctx.orders.findIndex(order => order.id === props.id);
                            const designIndex = ctx.orders[orderIndex].designs_orders.findIndex(
                                design => design.id === designOrder.id
                            );
                            ctx.handleChange({
                                orders: {
                                    [orderIndex]: {designs_orders: {$splice: [[designIndex, 1]]}}
                                }
                            });
                            ctx.handleFetchCart();
                        }}>
                        <span>Delete</span>
                        <span>Deleting...</span>
                    </PushableRequestButton>
                </div>
            )}
        </div>
    );
};
